export const waLink = (phone, text = "Bună ziua, sunt interesat de gama Medavita Instant Bond Repair.") => {
  let d = (phone || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  else if (d.startsWith("0")) d = `40${d.slice(1)}`;
  return d.length >= 9 ? `https://wa.me/${d}?text=${encodeURIComponent(text)}` : null;
};
